import { ChannelInfo } from 'interfaces/ChannelInfo';
import { InformationBanner } from 'interfaces/InformationBanner';

export const enum ConnectionActionType {
    SetConnected = 'CONNECTION/SET_CONNECTED',
    SetDisconnected = 'CONNECTION/SET_DISCONNECTED',
    SetAuthed = 'CONNECTION/SET_AUTHED',
    SetManualReconnect = 'CONNECTION/SET_MANUAL_RECONNECT',
    SetChannelInfo = 'CONNECTION/SET_CHANNEL_INFO',
    SetChannelInformBanner = 'CONNECTION/SET_CHANNEL_INFORM_BANNER',
    SetConnectionError = 'CONNECTION/SET_ERROR',
    SetVoTokenToStore = 'CONNECTION/SET_VO_TOKEN_TO_STORE',
}

export type SetConnectedAction = ReturnType<typeof setConnected>;
export const setConnected = (connected: boolean) => ({
    type: ConnectionActionType.SetConnected,
    payload: connected,
});

export type SetDisconnectedAction = ReturnType<typeof setDisconnected>;
export const setDisconnected = (disconnected: boolean) => ({
    type: ConnectionActionType.SetDisconnected,
    payload: disconnected,
});

export type SetAuthedAction = ReturnType<typeof setAuthed>;
export const setAuthed = (authed: boolean) => ({
    type: ConnectionActionType.SetAuthed,
    payload: authed,
});

export type SetManualReconnectAction = ReturnType<typeof setManualReconnect>;
export const setManualReconnect = (needed: boolean) => ({
    type: ConnectionActionType.SetManualReconnect,
    payload: needed,
});

export type SetChannelInfoAction = ReturnType<typeof setChannelInfo>;
export const setChannelInfo = (channelInfo: ChannelInfo) => ({
    type: ConnectionActionType.SetChannelInfo,
    payload: channelInfo,
});

export type SetChannelInformBannerAction = ReturnType<typeof setChannelInformBanner>;
export const setChannelInformBanner = (infromBanner: InformationBanner) => ({
    type: ConnectionActionType.SetChannelInformBanner,
    payload: infromBanner,
});

export type SetConnectionErrorAction = ReturnType<typeof setConnectionError>;
export const setConnectionError = (code: number, subCode?: number) => ({
    type: ConnectionActionType.SetConnectionError,
    payload: code != null && { code, subCode },
});

export type SetVoTokenToStoreAction = ReturnType<typeof setVoTokenToStore>;
export const setVoTokenToStore = (token: string) => ({
    type: ConnectionActionType.SetVoTokenToStore,
    payload: token,
});
